import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_206: DocMigration = {
  maxSchemaVersion: "0.0.206",
  description: "Visibility control of railings",
  apply(json: any) {
    // railings visibilities on sales view and brochure.
    for (const railingId in json.railings) {
      const railing = json.railings[railingId];
      if (railing.addToSalesViewPlan === undefined) {
        railing.addToSalesViewPlan = true;
      }
      if (railing.addToBrochurePlan === undefined) {
        railing.addToBrochurePlan = true;
      }
    }

    return json;
  },
};

export default migration_0_0_206;
